import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=1bce8d66&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=ts&"
export * from "./Page2.vue?vue&type=script&lang=ts&"
import style0 from "./Page2.vue?vue&type=style&index=0&id=1bce8d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce8d66",
  null
  
)

export default component.exports